<template>
  <div class="machine_type">
    <div class="top">
      <div class="left">
        <AgriculturalMachinery></AgriculturalMachinery>
      </div>
      <div class="middle">
        <Map></Map>
      </div>
      <div class="right">
        <MachineryNum></MachineryNum>
      </div>
    </div>
    <div class="bottom">
      <MachineryUsers></MachineryUsers>
      <WorkArea></WorkArea>
      <SumWorkingArea></SumWorkingArea>
    </div>
  </div>
</template>
<script>
import AgriculturalMachinery from './AgriculturalMachinery.vue'
import MachineryNum from './MachineryNum.vue'
import MachineryUsers from './MachineryUsers.vue'
import WorkArea from './WorkArea.vue'
import SumWorkingArea from './SumWorkingArea.vue'
import Map from './Map.vue'
export default {
  components:{
    AgriculturalMachinery, MachineryNum, MachineryUsers, WorkArea, SumWorkingArea, Map
  },
  data(){
    return{
      
    }
  },
  mounted(){

  },
  methods:{
    
  }
}
</script>
<style scoped>
  .machine_type{
    width: 98%;
    height: 100%;
    margin: 0 auto;
  }
  .top{
    width: 100%;
    height: 53.7vh;
    /* border: solid 1px #cccccc; */
    display: flex;
    margin-top: 1vh;
  }
  .left{
    width: 23%;
    height: 100%;
    background-image: url(../../../../static/img/ng-left.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin-right: 10px;
  }
  .right{
    width: 23%;
    height: 100%;
    background-image: url(../../../../static/img/ng-right.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .middle{
    width: 54%;
    height: 100%;
    background-image: url(../../../../static/img/ng-middle.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin-right: 10px;
  }
  .bottom{
    width: 100%;
    height: 29vh;
    margin-top: 1vh;
    /* background-image: url(../../../../static/img/ng-bottom.png);
    background-size: 100% 100%;
    background-repeat: no-repeat; */
    display: flex;
  }
</style>




// WEBPACK FOOTER //
// src/components/Index/view/MachineType.vue